import {
  VIEWING_FORM_FIELD_NAME,
  VIEWING_FORM_MODE,
  VIEWING_FORM_TIME_SOURCE,
} from '../../../RentalPortalViewingFormModal.constants'

export const VIEWING_FORM_MODE_RESET_VALUES = {
  [VIEWING_FORM_MODE.addSlot]: {
    [VIEWING_FORM_FIELD_NAME.slot]: null,
    [VIEWING_FORM_FIELD_NAME.timeSource]: VIEWING_FORM_TIME_SOURCE.adHoc,
  },
  [VIEWING_FORM_MODE.book]: {
    [VIEWING_FORM_FIELD_NAME.repeatUntil]: null,
    [VIEWING_FORM_FIELD_NAME.withRepeat]: false,
  },
}
